module.exports = __webpack_public_path__ + "static/downloable/formato-solicitud-de-renovacion-de-certificado-de-estudios.bf3485c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/formatos/formato-solicitud-de-renovacion-de-certificado-de-estudios.pdf
// module id = IK49
// module chunks = 1